import { env } from '../utils/env'

export const WORDPRESS_API_ROOT = env('REACT_APP_WORDPRESS_URL')
export const WORDPRESS_SUPPORT_FORM = WORDPRESS_API_ROOT + '/oth-support-request-form/'
export const WORDPRESS_BULK_ORDER_FORM = WORDPRESS_API_ROOT + '/oth-bulk-order-form/'
export const WORDPRESS_API_PATH = '/wp-json/wp/v2'
export const WORDPRESS_API = WORDPRESS_API_ROOT + WORDPRESS_API_PATH
export const WORDPRESS_BLOG_IMAGE_URL = WORDPRESS_API_ROOT + '/wp-content/uploads/'
